import React from 'react'
import { useParams } from 'react-router-dom'

import { Panel } from 'rsuite'
import WaitingCheckBusinessProfilesForm from '@components/businessProfiles/WaitingCheckBusinessProfilesForm'

export default function WaitingCheckBusinessProfilesFormPage () {
  const { brandSlug } = useParams<any>()

  return (
    <div className="ProductReviewModerationFormPage">
      <h1 className="u-heading">Модерирование компаний</h1>
      <Panel shaded>
        <WaitingCheckBusinessProfilesForm brandSlug={brandSlug} />
      </Panel>
    </div>
  )
}
